import { usePreferences } from "../../contexts/PreferencesContext";
import React, { useEffect, useRef, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { FaListAlt, FaVideo } from "react-icons/fa";
import { MdDelete, MdFileDownload, MdModeEdit, MdVideoLibrary } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";
import TableEmptyState from "../ReusableComponents/TableEmptyState";

import { Button } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import { saveAs } from 'file-saver';



const QuestionariosVinculados = (props) => {const { t } = usePreferences();

  const [lesson_cards, SetLessonCards] = useState(null);
  const [loading_screen, setLoadingScreen] = useState(true);
  const [loading_questionarios, setLoadingquestionarios] = useState(false);
  const [search_oficial, setSearchOficial] = useState('');

  const [questionarios, setquestionarios] = useState([]);
  const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });



  const [search, setSearch] = useState('');
  const { processo_id, processo_name, simulado, has_blocks } = props;
  const [show_warning, setShowWarning] = useState(false);
  const [questionarios_id, setRedacaoId] = useState(null);


  const [questaoSelect, setQuestaoSelect] = useState({});

  const [showModal, setShowModal] = useState(false);
  let refs = [];
  const dispatch = useDispatch();

  const Getquestionarios = async (page, search) => {

    let response = await Request.Get(`faculdade/get_questionarios_vinculados/${processo_id}?page=${page}&search=${search}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    if (response.pagination.current_page == page) {

      setquestionarios(response.questionarios);

      setPagination(response.pagination);
      setLoadingScreen(false);
      setLoadingquestionarios(false);


    }
  };






  const DeleteRedacao = async (questionarios_id) => {

    let response = await Request.Delete(`faculdade/desvincular_questionario/${questionarios_id}/${processo_id}`);
    console.log(response);
    if (response === undefined) return;

    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    Getquestionarios(pagination.current_page, search_oficial);



  };

  useEffect(() => {
    Getquestionarios(1, search_oficial);
  }, []);

  let pesquisarTimeout = null;
  const history = useHistory();
  return (
    <>


            {/* <hr /> */}
            {loading_screen == false && <div>
                <div className="module-card-container">

                    <div className="module-breadcrumb">

                        <button
              className="breadcrumb-back"
              onClick={() =>
              props.setState({
                activeTab: -1
              })
              }>{t("dashboard")}


            </button>

                        <span>/</span>

                        <strong>{t("questionnaires")}</strong>

                    </div>

                    <div className="module-title-row">

                        <div>

                            <h3 style={{ fontWeight: 'bold' }}>{`
                                ${t("questionnaires")}
                            `}</h3>

                            <p>{t("ui_gerencie_os_questionarios_vinculados_ao_processo_10b384f8")}

              </p>

                        </div>

                        <button
              className="btn-dashboard-modern"
              onClick={() =>
              props.setState({
                activeTab: -1
              })
              }>{`
                            ${t("legacy_dashboard")}
                        `}
            </button>

                    </div>
                    {/* <h4 className="mt-0 header-title" style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>Questões</h4> */}
                    {/* <br /> */}

                    <div className="module-toolbar">

                        <Search
              placeholder={t("legacy_pesquisar_pelo_nome_do_questionario")}
              ValueChange={(value) => {

                clearTimeout(pesquisarTimeout);

                setSearchOficial(value);

                pesquisarTimeout = setTimeout(() => {

                  let page = { ...pagination };

                  page.current_page = 1;

                  setPagination(page);

                  setLoadingquestionarios(true);

                  Getquestionarios(1, value);

                }, 500);

              }} />


                        {!simulado &&

            <Link
              to={`/questionarios_vinculados/register/${processo_id}`}
              className="btn-module-primary">


                                <FaListAlt />{t("ui_adicionar_questionarios_2a88af71")}



            </Link>

            }

                    </div>

                    <div className="table-modern-card">
                        <table id="tech-companies-1" className="table table-striped">
                            <thead>
                                <tr>

                                    <th>{t("label_name")}</th>
                                    <th>{t("legacy_numero_de_questoes")}</th>
                                    {has_blocks && <th>{t("label_block")}</th>}


                                    <th data-priority="3">{t("label_actions")}</th>

                                </tr>
                            </thead>
                            <tbody>
                                {loading_questionarios == false && questionarios.map((item, id) =>

                <tr key={id}>
                                        <td>

                                            <div className="redacao-name">

                                                <strong>
                                                    {item.name}
                                                </strong>

                                            </div>

                                        </td>
                                        <td>

                                            <div className="redacao-preview">

                                                {item.questoes.length}

                                                {' '}

                                                {item.questoes.length === 1 ?
                      'questão' :
                      'questões'}

                                            </div>

                                        </td>
                                        {has_blocks &&
                  <td>
                      <span className={`trust-badge ${item.block ? 'trust-low' : 'trust-medium'}`}>
                          {item.block ? item.block.name : t("label_without_block")}
                      </span>
                  </td>}
                                        {/* <td><img style={{ height: 60, width: 60, objectFit: 'contain' }} src={STORAGE_URL + STORAGE_URL + item.arquivo} /></td> */}

                                        <td>

                                            <div className="actions-group">

                                                <Link
                        to={`/questionarios_vinculados/show/${processo_id}/${item.id}`}>


                                                    <button
                          className="action-btn warning">

                                                        <BsFillEyeFill />
                                                    </button>

                                                </Link>

                                                <button
                        className="action-btn danger"
                        onClick={() => {

                          setRedacaoId(item.id);

                          setShowWarning(true);

                        }}>

                                                    <MdDelete />
                                                </button>

                                            </div>

                                        </td>

                                    </tr>
                )}

                            </tbody>
                        </table>
                        {loading_questionarios == true &&
            <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                {/* <div className="spinner-border text-primary" role="status"  >
                  </div> */}
                                <CircularProgress />
                            </div></div>

            }
                    </div>
                    {loading_questionarios == false && questionarios.length == 0 && <TableEmptyState title={t("ui_nenhum_questionario_encontrado_cc92c82e")} description={t("ui_vincule_o_primeiro_questionario_ao_processo_958376ac")} icon="📋" />}

                    <Pagination
            className={pagination.last_page == 1 ? "hide" : ""}
            style={{ display: "flex", justifyContent: "flex-end" }}
            count={pagination.last_page}
            value={pagination.current_page}
            onChange={(_, value) => {
              setLoadingquestionarios(true);
              console.log(_, value);
              let page = { ...pagination };
              page.current_page = value;
              setPagination(pagination);
              Getquestionarios(value, search_oficial);
            }} />

                </div>

                {/* {this.state.andamento == true && <AvaliacaoAndamento get_questionarios={this.get_questionarios.bind(this)} {...this.props} />} */}

            </div>}

            {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                {/* <div className="spinner-border text-primary" role="status"  >
            </div> */}
                <CircularProgress />
            </div></div>}

            <SweetAlert
        warning
        title={t("legacy_atencao")}
        onConfirm={() => {
          setShowWarning(false);
          setLoadingquestionarios(true);
          DeleteRedacao(questionarios_id);
          // this.delete_banner(this.state.banner_to_delete);
        }}
        onCancel={() => {
          setShowWarning(false);
        }}
        show={show_warning}
        confirmBtnText={t("ui_sim_desejo_desvincular_91364237")}
        cancelBtnText={t("legacy_cancelar")}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        showCancel={true}>{t("ui_ao_desvincular_este_questionario_ele_nao_estara_ma_574217ce")}


      </SweetAlert>


        </>);


};

export default QuestionariosVinculados;
